module.exports = __webpack_public_path__ + "media/images/flags/4x3/mco-5c5b19d1f3f8041a069f256906bb8beb.svg";